export default __webpack_public_path__ + "static/media/brand.15d8be7e.png";